import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import SvgIcon from "vue-svgicon";
import {
  hasToken,
  setTokenToStore,
  getPartnerUserAndContracts,
  setGAParams
} from "@/helpers/auth-helper";
import { setZendeskWidget } from "@/helpers/zendesk-helper";
import { setSentry, setSentryUser } from "@/helpers/sentry-helper";
import { redirectWhenIsNotOnboardingFinished } from "./helpers/router-helper";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/ja";
import VueCompositionAPI from "@vue/composition-api";
import VueInputAutoWidth from "vue-input-autowidth";
import VTooltip from "v-tooltip";
import "v-tooltip/dist/v-tooltip.css";
import "vue2-timepicker/dist/VueTimepicker.css";

dayjs.locale("ja");
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

Vue.use(SvgIcon, {
  tagName: "svg-icon",
  isOriginalDefault: true
});
Vue.use(VueCompositionAPI);
Vue.use(VueInputAutoWidth);
VTooltip.options.themes["menu-dropdown"] = {
  $extend: "dropdown",
  placement: "bottom-start",
  offset: [0, 10],
  $resetCss: true
};
VTooltip.options.themes["select-box-dropdown"] = {
  $extend: "dropdown",
  placement: "bottom-start",
  offset: [0, 0],
  $resetCss: true
};
Vue.use(VTooltip);

Vue.config.productionTip = false;

// NOTE: アクセス直後の処理
(async () => {
  setSentry();
  if (hasToken()) {
    setTokenToStore();
    await getPartnerUserAndContracts();
    setGAParams();
    setZendeskWidget();
    setSentryUser();
    redirectWhenIsNotOnboardingFinished();
  }
})();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
